import { AfterViewInit, Component, inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { ClarityModule } from "@clr/angular";
import { filter, Subscription } from 'rxjs';
import { BrandingService } from './_shared/services/branding.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    ClarityModule,
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass'
})
export class AppComponent {
  private readonly documentRef = inject(DOCUMENT);
  private readonly brandTitle: string;
  private readonly routerSubscription: Subscription;

  constructor(
    private readonly documentTitle: Title,
    private readonly router: Router,
    private readonly brandingService: BrandingService,
  ) {
    const branding = this.brandingService.getAssets();
    this.brandTitle = branding.appTitle;
    this.documentTitle.setTitle(`${branding.appTitle} by w.media`);
    this.documentRef.documentElement.style.setProperty('--tenant-brand-font-family', branding.fontFamily);

    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.scheduleStaticBrandingRefresh());
  }

  ngAfterViewInit(): void {
    this.scheduleStaticBrandingRefresh();
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  private scheduleStaticBrandingRefresh(): void {
    window.requestAnimationFrame(() => this.replaceLegacyStaticTitles());
  }

  private replaceLegacyStaticTitles(): void {
    const headings = this.documentRef.querySelectorAll('h1, h2, h3, h4');

    headings.forEach((heading) => {
      heading.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue) {
          return;
        }

        let nextValue = node.nodeValue.replace(/\bPHM PPS\b/g, this.brandTitle);
        if (!nextValue.includes(this.brandTitle)) {
          nextValue = nextValue.replace(/^(\s*)PPS\b/, `$1${this.brandTitle}`);
        }

        if (nextValue !== node.nodeValue) {
          node.nodeValue = nextValue;
        }
      });
    });
  }
}
